import { CSVLink } from 'react-csv';
import { BUTTON_SIZES, IconButton, BUTTON_VARIANTS } from 'ui/button';
import { Export24 } from 'ui/icons';
import { useSnippetsContext } from '../context';

const csvCampaignModeHeaders = [
  'snippetName',
  'dynamicUrl',
  'url',
  'campaignName',
  'TotalSent',
  'TotalClicks',
  'UniqueClicks',
  'ClickRate',
];

const csvSnippetsModeHeaders = [
  'snippetName',
  'parentSnippet',
  'dynamicUrl',
  'url',
  'TotalSent',
  'TotalClicks',
  'UniqueClicks',
  'ClickRate',
];

export const CSVButton = () => {
  const { showCampaigns, csvData = [] } = useSnippetsContext();

  return (
    <CSVLink
      headers={showCampaigns ? csvCampaignModeHeaders : csvSnippetsModeHeaders}
      data={csvData}
      filename={showCampaigns ? 'snippet_campaigns_table.csv' : 'snippets_table.csv'}
    >
      <IconButton size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.SECONDARY}>
        <Export24 />
      </IconButton>
    </CSVLink>
  );
};
